module.exports = __webpack_public_path__ + "static/media/modalperson.158465b4.svg";